const comments = [
  {
    name: '追剧小达人',
    avatar: '追',
    time: '2小时前',
    text: '番茄影视大全真的是我每天的快乐源泉！更新速度太快了，昨晚播的剧今天就能看，画质也很清晰，关键是免费。已经推荐给身边所有追剧的朋友了。',
    tag: '忠实用户',
  },
  {
    name: '深夜看剧人',
    avatar: '夜',
    time: '5小时前',
    text: '用了大半年的番茄追剧，资源真的很全，连一些小众的日剧都有。播放流畅不卡顿，晚上高峰期看也完全没问题，比很多付费平台体验还好。',
    tag: '老用户',
  },
  {
    name: '剧荒拯救者',
    avatar: '剧',
    time: '昨天',
    text: '之前总是剧荒不知道看什么，番茄影视大全的推荐太准了！每次看完一部剧自动推荐相似的，已经在这里发现了十几部宝藏剧集，收藏夹都满了。',
    tag: '活跃用户',
  },
  {
    name: '韩剧爱好者',
    avatar: '韩',
    time: '2天前',
    text: '作为一个韩剧迷，番茄影视大全的韩剧资源太丰富了。最新播出的韩剧隔天就有中字更新，而且分类很清晰，找剧超级方便。给五星好评！',
    tag: '新用户',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            追剧小伙伴怎么说
          </h2>
          <p className="text-sm text-foreground-600">来自番茄影视大全真实用户的评价</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-xl p-5 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 font-bold text-sm flex-shrink-0">
                  {comment.avatar}
                </span>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{comment.name}</span>
                    <span className="text-[10px] px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded whitespace-nowrap">{comment.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.text}</p>
              <div className="flex items-center gap-0.5 mt-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}